import httpService from './httpService';

export interface IDocuSignData {
  date: Date;
  envelopeId: string;
  isSigned: boolean;
  name: string;
  recipientId: number;
  role: string;
  signEnvelopeId: number;
  status: any;
  type: string;
}

export interface IDocuSignUri {
  uri: string;
}

export interface IDocuSignEnvelopeData {
  documents: IEnvelopeDocument[];
  recipient: IEnvelopeRecipient;
}

export interface IEnvelopeDocument {
  id: number;
  documentId: number;
  objectId: number;
  name: string;
  objectType: string;
  documentName: string;
  documentLabel: string;
}
export interface IEnvelopeRecipient {
  id: number;
  signEnvelopeId: number;
  commContactId: number;
  contactId: number;
  name: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  role: string;
  type: string;
  isSigned: boolean;
  status: string;
}

export const getSignRequirements = () => {
  let endpoint = httpService.getEndpointURL(`/Documents/sign/requirements`);
  return httpService
    .get(endpoint)
    .then((res) => res.data)
    .catch((err) => {
      console.log('> getSignRequirements error ', err);
    });
};

export const generateDocuSignURL = (recipientId: number, cancelToken) => {
  let returnURL = '';
  if (location.hostname === 'localhost') {
    returnURL = 'https://' + location.hostname + ':' + location.port + `/docusign/redirect/${recipientId}`;
  } else {
    returnURL = 'https://' + location.hostname + `/docusign/redirect/${recipientId}`;
  }
  let body = { returnUrl: returnURL };
  let endpoint = httpService.getEndpointURL(`/DocuSignEnvelopes/sign/${recipientId}/uri`);
  return httpService
    .post(endpoint, body, { cancelToken })
    .then((res) => res.data)
    .catch((err) => {
      console.log('> generateDocuSignURL error ', err);
    });
};

export const updateEnvelopeState = (recipientId: number) => {
  let endpoint = httpService.getEndpointURL(`/DocuSignEnvelopes/${recipientId}/state`);
  return httpService
    .post(endpoint)
    .then((res) => res.data)
    .catch((err) => {
      console.log('> updateEnvelopeState error ', err);
    });
};
